import type { Bridge } from '../../contracts/bridge';
import type { SurfaceModelOutput } from '../../contracts/modeling';

interface ForecastPanelProps {
  bridge: Bridge;
  forecast: SurfaceModelOutput[];
}

export function ForecastPanel({ bridge, forecast }: ForecastPanelProps) {
  return (
    <div>
      <div className="panel-header">
        <h3 className="panel-title">72-Hour Forecast</h3>
        <div className="panel-actions">
          <button className="btn btn--ghost btn--sm">Export</button>
        </div>
      </div>

      <div className="flex flex-col gap-2">
        <p className="text-sm text-secondary">
          Surface temperature and ice accumulation forecast for {bridge.name}
        </p>

        {forecast.length === 0 ? (
          <div className="p-4 text-center text-secondary">
            <p>No forecast data available.</p>
            <p className="text-xs mt-2">
              Run a forecast from the Overview panel to see predictions.
            </p>
          </div>
        ) : (
          <div className="mt-4">
            <div className="chart-placeholder">
              <span className="text-secondary text-sm">
                Chart visualization placeholder
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
